/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_502Inputs */

const vi_carrier_status_502 = /** @type {(inputs: Carrier_Status_502Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển hoàn bưu cục gốc`)
};

/**

* @param {Carrier_Status_502Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_502 = /** @type {((inputs?: Carrier_Status_502Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_502Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_502(inputs)
});